var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-7"},[_c('Table',{attrs:{"columns":_vm.columns,"size":"small","data":_vm.resources,"max-height":"700","highlight-row":"","stripe":""},scopedSlots:_vm._u([{key:"uom",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.u_o_m ? row.u_o_m.uom_name_en : null)+"\n    ")]}},{key:"salecode",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.sale_code ? row.sale_code : null)+"\n    ")]}},{key:"quantityInHand",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.product_price ? row.product_price.quantity_in_hand : null)+"\n    ")]}},{key:"costprice",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.product_price
          ? parseFloat(row.product_price.cost).toFixed(2)
          : null)+"\n    ")]}},{key:"saleprice",fn:function(ref){
          var row = ref.row;
return [_vm._v(_vm._s(row.product_price
          ? parseFloat(row.product_price.sale_price).toFixed(2)
          : null)+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }